import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"

import "./header.css"

// { text: "Articles", link: "/blog" },
// { text: "Portfolio", link: "/portfolio" },

const headerLinks = [
  // { text: "Home", link: "/" },
  // { text: "About", link: "/about" },
]

const Header = (props, { siteTitle }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className={`${props.hideOnMobile ? "hidden-mobile" : ""}`}>

        <a
          href="/"
          className="logo logo-mobile"
        >&#60; <b>Steve Baker</b> /&#62;</a>
        <div className="header-content">

          <a
            href="/"
            className="logo logo-desktop"
          >&#60; <b>Steve Baker</b> /&#62;</a>

          <h1>
            <Link
              to="/"
              style={{
                color: "white",
                textDecoration: `none`,
              }}
            >
              {siteTitle}
            </Link>
          </h1>
          <div className="header-links">
            {headerLinks.map(link => (
              <Link to={link.link} key={link.link}>
                {link.text}
              </Link>
            ))}
          </div>
        </div>
      </header>
      <div
        tabIndex="0"
        role="button"
        aria-label="expand nav bar"
        className={`header-menu ${isOpen ? "change" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        hidden={headerLinks.length > 1 ? "false" : "hidden"}
      >
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </div>

      <div className={`header-links-mobile ${isOpen ? "open" : "closed"}`}>
        {/* <div className="header-links-placeholder"></div> */}
        {headerLinks.map(link => (
          <Link to={link.link} key={link.link} onClick={() => setIsOpen(false)}>
            {link.text}
          </Link>
        ))}
      </div>
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  hideOnMobile: PropTypes.bool,
}

Header.defaultProps = {
  siteTitle: ``,
  hideOnMobile: false,
}

export default Header
